module.exports = __webpack_public_path__ + "static/media/IsimIcinFavicon.be02a6fd.png";